import withTheme from 'modules/hoc/withTheme'

import theme from './theme.scss'

export default withTheme(theme)
